<template lang="html">
    <section class="choose-app">
        <h1>בחר אפליקציה</h1>
        <div class="row apps-row mt-5">
            <div class="app">אפליקציית כאן
                <router-link to="history/kan"><img class="imageApp" src="/img/screenshot/kan.jpeg" />
                </router-link>
            </div>
            <div class="app" v-if="hasPermission('hinuchitMain')">חינוכית
                <router-link to="history/hinuchit"><img class="imageApp" src="/img/screenshot/hinuchit.jpeg" /></router-link>
            </div>
            <div class="app" v-if="hasPermission('stickersMain')">סטיקרים
                <router-link to="history/stickers"><img class="imageApp" src="/img/screenshot/stickers.jpeg" /></router-link>
            </div>
        </div>
        <v-btn color="primary" to="admin" v-if="isAdmin" class="mt-5"><v-icon>mdi-account-multiple</v-icon>ניהול משתמשים ></v-btn>
    
    
    </section>
</template>

<script lang="js">
export default {
    name: 'choose-app',
    props: [],
    mounted() {

    },
    data() {
        return {

        }
    },
    methods: {
        hasPermission(app) {
            return this.segments && this.segments.includes(app)
        }
    },
    computed: {
        isAdmin() {
            return this.$store.getters.userClaims.admin
        },
        segments() {
            return this.$store.getters.userClaims.segments
        }
    }
}
</script>

<style scoped lang="scss">
.imageApp {
    width: 300px;
    margin: 10px;
}

.app {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.apps-row {
  display: flex;
  justify-content: center;
}
.choose-app {
    align-items: center;
    display: flex;
    flex-direction: column;
}

@media(max-width: 700px){
.imageApp {
    height: 20vh;
    margin: 10px;
    object-fit: cover;
    
}

}
</style>
